import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-admin-form-actions',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule],
  templateUrl: './admin-form-actions.component.html',
  styleUrl: './admin-form-actions.component.scss',
})
export class AdminFormActionsComponent {
  @Input() primaryLabelKey = 'COMMON.SAVE';
  @Input() submittingLabelKey = 'COMMON.SAVING';
  @Input() secondaryLabelKey = 'COMMON.CANCEL';
  @Input() submitting = false;
  @Input() disablePrimary = false;
  @Input() showCancel = false;

  @Output() cancel = new EventEmitter<void>();
}
